export const products = [
    {
        id: 1,
        img: "https://1000marcas.net/wp-content/uploads/2020/02/GitHub-logo-1.jpg",
        link: "https://github.com/AlexLosadaC"
    },
    {
        id: 2,
        img: "https://github.com/AlexLosadaC/frontend-flipgram/blob/master/screeshots/screeen1.png?raw=true",
        link: "https://github.com/AlexLosadaC/frontend-flipgram"
    },
    {
        id: 3,
        img: "https://mirayhazlo.com/wp-content/uploads/2019/07/node-logo.png",
        link: "https://github.com/AlexLosadaC/Flipgram-backend"
    },
    {
        id: 4,
        img: "https://mirayhazlo.com/wp-content/uploads/2019/07/node-logo.png",
        link: "https://github.com/AlexLosadaC/revisionadodecoches"
    },
    {
        id: 6,
        img: "https://1000marcas.net/wp-content/uploads/2019/12/Spotify.jpg",
        link: "https://open.spotify.com/artist/2XasCecpx5c6THUvAkE8j8?si=EIlTe-_eTwCvAImao4QtJw"
    }
]